import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';
import 'assets/scss/formvalidate.css';

const CustomSurveyModal = ({
  modalToggle,
  cancelDelete,
  confirmDeleteCustomSurvey,
  toDeleteCustomSurvey,
}) => (
  <Modal visible={modalToggle} onClickBackdrop={cancelDelete}>
    <div className="modal-header">
      <h5 className="modal-title">Delete Survey </h5>
      <span
        onClick={cancelDelete}
        className=" cursor-pointer close-delete-popup"
      >
        X
      </span>
    </div>
    <div className="modal-body">
      <p>
        Are you sure you want to delete the survey{' '}
        <span className="font-weight-bold">{toDeleteCustomSurvey.name}</span>?
      </p>
      <p>
        (Deleting this Survey will delete all Questions and Reports associated
        with this survey.)
      </p>
      <p> This action cannot be undone </p>
    </div>
    <div className="modal-footer">
      <button
        type="button"
        className="btn btn-secondary"
        onClick={cancelDelete}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={confirmDeleteCustomSurvey}
      >
        Delete
      </button>
    </div>
  </Modal>
);

CustomSurveyModal.defaultProps = {
  modalToggle: () => {},
  cancelDelete: () => {},
  confirmDeleteCustomSurvey: () => {},
  toDeleteCustomSurvey: {},
};

CustomSurveyModal.propTypes = {
  modalToggle: PropTypes.func,
  cancelDelete: PropTypes.func,
  confirmDeleteCustomSurvey: PropTypes.func,
  toDeleteCustomSurvey: PropTypes.shape({
    name: PropTypes.string,
  }),
};

export default CustomSurveyModal;



// WEBPACK FOOTER //
// ./src/components/customSurvey/CustomSurveyModal.js